import React from 'react'

function NotFound() {
    return (
        <div>
            NOT FOUND
        </div>
    )
}

export default NotFound